module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_sola-bc859a1a08d49385227625bdc984ff60.svg";